import { render, staticRenderFns } from "./ItemToevoegen.vue?vue&type=template&id=1046e095&"
import script from "./ItemToevoegen.vue?vue&type=script&lang=js&"
export * from "./ItemToevoegen.vue?vue&type=script&lang=js&"
import style0 from "./ItemToevoegen.vue?vue&type=style&index=0&id=1046e095&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports